import { useState } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { googleProvider } from "../../firebaseConfig";
import { signin, signInWithProvider } from "../../redux/auth/authActions";

const SignInPage = ({ auth, signInWithProvider }) => {

    const [loading, setLoading] = useState(false);

    
    if(auth.user !== null) {
        return <Redirect to="/" />;
    }

    const handleOnClick = async (provider) => {
        setLoading(true);
        signInWithProvider(provider);
        setLoading(false);
    }

    return (
        <div className="min-h-screen flex items-center">
            <div className="container mx-auto max-w-md transition duration-300">

            
            <div className="flex space-x-2">
                <Link to="https://vue-diamond-topup.web.app" target="blank" className="w-full bg-blue-400 rounded-lg sahdow-lg p-12 flex flex-col justify-center items-center hover:bg-blue-600 backdrop-filter backdrop-blur-lg bg-opacity-20 hover:bg-opacity-20 overflow-hidden shadow">
                    <img className="w-full" src="https://vuejs.org/images/logo.svg" alt="vue"/>
                </Link>
                <Link to="https://kopacopy-diamond-topup.firebaseapp.com/" target="blank" className="w-full bg-blue-400 rounded-lg sahdow-lg p-12 flex flex-col justify-center items-center hover:bg-blue-600 backdrop-filter backdrop-blur-lg bg-opacity-20 hover:bg-opacity-20 overflow-hidden shadow">
                    <img className="w-full" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K" alt="react"/>
                </Link>
            </div>

                <form action="">
                    <div className="m-3 py-12 p-10 bg-white rounded-xl backdrop-filter backdrop-blur-lg bg-opacity-20 hover:bg-opacity-20 overflow-hidden shadow">
                        {auth.error && (
                        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-3" role="alert">
                            <p className="font-bold">Login Failed</p>
                            <p>{auth.error}</p>
                        </div>
                        )}

                        {/* <div className="mb-3">
                            <label className="mr-4 text-gray-700 font-bold inline-block mb-2">Email</label>
                            <input ref={emailRef} type="email" className="border bg-gray-100 py-2 px-4 w-96 outline-none focus:ring-2 focus:ring-indigo-400 rounded" placeholder="Your email..." />
                        </div>
                        <div className="mb-6">
                            <label className="mr-4 text-gray-700 font-bold inline-block mb-2">Password</label>
                            <input ref={passwordRef} type="password" className="border bg-gray-100 py-2 px-4 w-96 outline-none focus:ring-2 focus:ring-indigo-400 rounded" placeholder="Your name..." />
                        </div>
                        

                        <button onClick={signIn} type="button" className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-center leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150">
                            {loading ? (
                                <>
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Processing
                                </>
                            ) : ('Signin') }
                        </button> */}
                        <button onClick={() => handleOnClick(googleProvider)} type="button" className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-center leading-6 font-medium rounded-md bg-white hover:bg-gray-200 transition ease-in-out duration-150">
                            {loading ? (
                                <>
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Processing
                                </>
                                
                            ) : (<>
                                <svg className=" -ml-1 mr-3 h-5 w-5" viewBox="0 0 40 40">
                                    <path d="M36.3425 16.7358H35V16.6667H20V23.3333H29.4192C28.045 27.2142 24.3525 30 20 30C14.4775 30 10 25.5225 10 20C10 14.4775 14.4775 9.99999 20 9.99999C22.5492 9.99999 24.8683 10.9617 26.6342 12.5325L31.3483 7.81833C28.3717 5.04416 24.39 3.33333 20 3.33333C10.7958 3.33333 3.33335 10.7958 3.33335 20C3.33335 29.2042 10.7958 36.6667 20 36.6667C29.2042 36.6667 36.6667 29.2042 36.6667 20C36.6667 18.8825 36.5517 17.7917 36.3425 16.7358Z" fill="#FFC107"/>
                                    <path d="M5.25497 12.2425L10.7308 16.2583C12.2125 12.59 15.8008 9.99999 20 9.99999C22.5491 9.99999 24.8683 10.9617 26.6341 12.5325L31.3483 7.81833C28.3716 5.04416 24.39 3.33333 20 3.33333C13.5983 3.33333 8.04663 6.94749 5.25497 12.2425Z" fill="#FF3D00"/>
                                    <path d="M20 36.6667C24.305 36.6667 28.2167 35.0192 31.1742 32.34L26.0159 27.975C24.3425 29.2425 22.2625 30 20 30C15.665 30 11.9842 27.2359 10.5975 23.3784L5.16254 27.5659C7.92087 32.9634 13.5225 36.6667 20 36.6667Z" fill="#4CAF50"/>
                                    <path d="M36.3425 16.7358H35V16.6667H20V23.3333H29.4192C28.7592 25.1975 27.56 26.805 26.0133 27.9758C26.0142 27.975 26.015 27.975 26.0158 27.9742L31.1742 32.3392C30.8092 32.6708 36.6667 28.3333 36.6667 20C36.6667 18.8825 36.5517 17.7917 36.3425 16.7358Z" fill="#1976D2"/>
                                </svg>
                                Signin with Google
                                </>) }
                        </button>
                        {/* <h6>Not yet register? <span onClick={signUp} className="signin__link">Sign up</span></h6> */}
                    </div>
                </form>
            </div>
        </div>
    )
}


const mapStateToProps = state => {
    return {
        auth: state.auth
    };
}


const mapDispatchToProps = dispatch => {
    return {
        signin: user => dispatch(signin(user)),
        signInWithProvider: (provider) => dispatch(signInWithProvider(provider)),
    }
}
 
export default connect(mapStateToProps,mapDispatchToProps)(SignInPage);